import(/* webpackMode: "eager" */ "/vercel/path0/app/settings/page.tsx");
